import React,{useState,useEffect} from 'react';
import {Offcanvas, Form, Button} from 'react-bootstrap';
import { Preferences } from '@capacitor/preferences';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { useLanguage } from '../i18n/LanguageContext';

function Note(props){
  const { t } = useLanguage();
  var savedNote = "";
  if (props.saved){
    savedNote = props.saved.note;
  }
  const [show, setShow] = useState(props.show);
  const [note, setNote] = useState(savedNote);
  const [title, setTitle] = useState(props.title);

  useEffect(() => {
    if (props.title != title){
      setTitle(props.title);
      setNote("");//Clear the note
    }
   
  },[props.title] );

  function handleTitleUpdate(e){
    var title = e.currentTarget.value;
    setTitle(title);
  }

  function handleNoteUpdate(e){
    var note = e.currentTarget.value;
    setNote(note);
  }

  function handleClose(){
    setShow(false);
    props.onHide(false);
  } 

  function handleSave(){
    var card = saveCard()
    setShow(false);
    props.onHide(true, card);
  } 

  function saveCard(){
      var today = new Date();
      var now = today.getTime();
      const month = new Array();
      var card;
      month[0] = "Jan";
      month[1] = "Feb";
      month[2] = "Mar";
      month[3] = "Apr";
      month[4] = "May";
      month[5] = "Jun";
      month[6] = "Jul";
      month[7] = "Aug";
      month[8] = "Sep";
      month[9] = "Oct";
      month[10] = "Nov";
      month[11] = "Dec";
      var date =  today.getDate() + ' ' + month[today.getMonth()] + ' ' + today.getFullYear();
      var hours = today.getHours();
      var ampm = " AM"
      if (hours > 12){
        ampm = " PM"
        hours = hours - 12;
      }
      var time = hours + ':' + padding(today.getMinutes()) + ampm;
      var timestring = date + ' | ' + time;

      if (props.saved && props.card){
        var card = {key:props.saved.key, time:props.saved.time, card:props.card, type:props.saved.type, title:title, note:note};
        storageSet(props.saved.key, card);
        return card;
      }
      else if(props.saved && props.cards){
      var card = {key:props.saved.key, time:props.saved.time, cards:props.cards, type:props.saved.type, title:title, note:note};
        storageSet(props.saved.key, card);
        return card;
     }
      else if (props.card){
        var card = {key:now, time:timestring, card:props.card, type:props.type, title:title, note:note}
        storageSet(now, card);
        return card;
      }
      else if (props.cards){
        //Save only moved cards
        var cardsToSave = [];
        props.cards.forEach(function(c){
          if (c.x != null && c.y != null && c.x == 0 && c.y == 0){
            //Not moved
          }
          else{
            //moved
            cardsToSave.push(c);
          }
        });

        var cards = {key:now, time:timestring, cards:cardsToSave, type:props.type, title:title, note:note, rotation: props.rotation};
        storageSet(now,cards);
        return cards;
      }
      
  }

  function padding(num){
    var padded = num.toString();
    if (num < 10){
      padded = '0' + num.toString();
    }
    
    return padded;
  }
  async function storageSet(key, value){
    await Preferences.set({
      key: key.toString(),
      value: JSON.stringify(value),
    });
    
    Promise.resolve();
  }
  

  function getModal(){
    
    return (
      <Offcanvas className="semibackground note" show={show} onHide={handleClose} {...props} placement={'end'}>
      <Offcanvas.Header style={{paddingTop:'calc(env(safe-area-inset-top))'}} closeButton>
        <Offcanvas.Title><div>{t('noteModal.title')}</div></Offcanvas.Title>
        <div style={{color:'cornflowerblue'}} onClick={handleSave}><FontAwesomeIcon icon={faSave}  size='1x'/> {t('noteModal.done')}</div>
      </Offcanvas.Header>
      <Offcanvas.Body style={{paddingTop:0}}>
      <div style={{overflowY:'auto', height:'100%', textAlign:'center'}}>
                  <Form.Control 
                  placeholder={t('noteModal.titlePlaceholder')}
                  onChange={handleTitleUpdate}
                  value={title}
                  />
                  
                  <Form.Control as="textarea" style={{height:'90%'}} 
                  placeholder={t('noteModal.contentPlaceholder')}
                  onChange={handleNoteUpdate}
                  value={note}/>
                  

                  </div>
      </Offcanvas.Body>
      </Offcanvas>
    )
  }

  const handleShow = () => setShow(true);


  return (
    getModal()
  )
};

export default Note;